module.exports = __webpack_public_path__ + "img/papua_new_guinea.6cb3aa2.webp";